export default class Presse {
    index = -1;
    count = 1;
    constructor({ el }) {
        this.el = el;

        this.initialize();
    }
    initialize() {
        this.$data = this.el.querySelectorAll(".main-data")
        this.$image = this.el.querySelectorAll(".button")
        this.count = this.$data.length
        
        this.setIndex(0);

        this.$image.forEach((nav, index) => {
            nav.addEventListener("click", () => this.setIndex(index))
        })
    }
    setIndex(idx) {        
        const state = Flip.getState(this.el.querySelector(".flipper"));
        
        const leaver = this.$data[this.index];
        if (leaver) {
            gsap.set(leaver, { position: "absolute", inset: 0 });
            gsap.to(leaver, { alpha: 0, duration: .314, clearProps: "all", onComplete: () => {
                leaver?.classList.add("hidden")
            }});
        }

        this.$image.forEach((nav) => {
            nav.classList.remove('active');
        })
        this.$data[idx].classList.remove("hidden")
        this.$image[idx].classList.add('active')

        gsap.set(this.$data[idx], { position: "static" });
        gsap.from(this.$data[idx], { alpha: 0, delay: .314, duration: .314 });

        this.index = idx

        Flip.from(state, {
            duration: 0.628 ,
            ease: "quint.out",
            onComplete: () => {
                ScrollTrigger.refresh();
            }
        });
    } 

    dispose() {

    }
}